import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import Paper from 'material-ui/Paper';


const row = r => (
  <TableRow key={r[1]}>
    <TableCell>{r[0]}</TableCell>
    <TableCell numeric>{'$' + r[2].toLocaleString()}</TableCell>
    <TableCell numeric>{'$' + r[3].toLocaleString()}</TableCell>
  </TableRow>
)

const styles = theme => ({
  root: {
    width: '90%',
    margin: "40px auto 10px",
    overflowX: 'auto',
  },
  table: {
  },
});

function SimpleTable(props) {
  const { classes, school } = props;

  return (
      <div style={{marginTop: "60px"}}>
      <div>{`${school["School Name"]} is a ${school["Ownership"]} ${school["Type"]} school with roll of ${school["July Roll"].toLocaleString()}.`}</div>
      <div style={{marginTop: "20px"}}>{`${school["School Name"]} has a total revenue of $${school["Total"].toLocaleString()}. This is `}
          <span style={{color: "red"}}> {`$${school["Per Student"].toLocaleString()}`}</span> {`per student.`}</div>
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Funding Category</TableCell>
            <TableCell numeric>Per Student ($)</TableCell>
            <TableCell numeric>Total ($)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {school.highLevel.map(row)}
        </TableBody>
      </Table>
    </Paper>
    <div style={{marginTop: "20px"}}>Detailed Categories</div>
    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Funding Category</TableCell>
            <TableCell numeric>Per Student ($)</TableCell>
            <TableCell numeric>Total ($)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {school.lowLevel.map(row)}
        </TableBody>
      </Table>
    </Paper>
  </div>
  );
}

SimpleTable.propTypes = {
  classes: PropTypes.object.isRequired,
  school: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleTable);



// WEBPACK FOOTER //
// ./src/Table.js